import React from "react";
import { View } from "react-native";
import describeArc from "./ArcGenerator";

const Field2D = (props) => {
  const lineColor = props.lineColor || "rgba(255,255,255,1)";
  const { width, height, unitX, unitY } = props;
  return (
    <View
      style={{
        width: width,
        height: height,
        position: "absolute",
        zIndex: 3,
        padding: 0.1,
      }}
    >
      {width && height && (
        <svg height="100%" width="100%" viewBox={"0 0 " + width + " " + height}>
          {/*Left Inner Goal  */}
          <rect
            x={0}
            y={0}
            width="100%"
            height="100%"
            strokeWidth={props.lineThickness ? props.lineThickness + 1 : 4}
            stroke={lineColor}
            fill="transparent"
          />
          <rect
            x={-6}
            y={unitY * 3 - 2}
            width={unitX * 0.5}
            height={unitY * 2 + 4}
            strokeDasharray={3}
            strokeDashoffset={2}
            strokeWidth={props.lineThickness ? props.lineThickness - 1 : 3}
            stroke={lineColor}
            fill="transparent"
          />

          {/*Left  D-Box  */}
          <rect
            x={-2}
            y={unitY * 2 - 2}
            width={unitX * 2}
            height={unitY * 4 + 2}
            strokeWidth={props.lineThickness ? props.lineThickness : 3}
            stroke={lineColor}
            fill="transparent"
          />

          {/*LEFT TOP ARC */}
          <path
            d={describeArc(-5, 0, unitX * 0.3, 0, 180)}
            stroke={lineColor}
            fill="transparent"
            strokeWidth={props.lineThickness ? props.lineThickness : 3}
          />
          {/*LEFT BOTTOM ARC */}
          <path
            d={describeArc(-5, height, unitX * 0.3, 0, 180)}
            stroke={lineColor}
            fill="transparent"
            strokeWidth={props.lineThickness ? props.lineThickness : 3}
          />
          {/*LEFT D-BOX ARC */}
          <path
            d={describeArc(
              unitX + unitX * 0.2,
              height / 2,
              unitX + 6,
              30 + unitY * 0.3,
              150 - unitY * 0.3
            )}
            stroke={lineColor}
            fill="transparent"
            strokeWidth={props.lineThickness ? props.lineThickness : 3}
          />

          {/*LEFT D-BOX POINT */}
          <circle
            cx={unitX + unitX * 0.2}
            cy={height / 2}
            r={props.lineThickness ? props.lineThickness : 2}
            fill={lineColor}
          />

          {/*Center POINT */}
          <circle
            cx={width / 2}
            cy={height / 2}
            r={props.lineThickness ? props.lineThickness + 1 : 3}
            fill={lineColor}
          />
          {/*Center Circle*/}
          <circle
            cx={width / 2}
            cy={height / 2}
            r={unitY + 7}
            fill="transparent"
            stroke={lineColor}
            strokeWidth={props.lineThickness ? props.lineThickness : 3}
          />
          <line
            x1={width / 2}
            y1={0}
            x2={width / 2}
            y2={height}
            fill="transparent"
            stroke={lineColor}
            strokeWidth={props.lineThickness ? props.lineThickness : 3}
          />

          {/*Right Inner Goal  */}
          <rect
            x={width - unitX * 0.4}
            y={unitY * 3 - 2}
            width={unitX * 0.5}
            height={unitY * 2 + 4}
            strokeDasharray={3}
            strokeDashoffset={2}
            strokeWidth={props.lineThickness ? props.lineThickness - 1 : 3}
            stroke={lineColor}
            fill="transparent"
          />
          {/*Right D-Box  */}
          <rect
            x={width - unitX * 2}
            y={unitY * 2 - 2}
            width={unitX * 2}
            height={unitY * 4 + 2}
            strokeWidth={props.lineThickness ? props.lineThickness : 3}
            stroke={lineColor}
            fill="transparent"
          />
          {/*Right TOP ARC */}
          <path
            d={describeArc(width + 5, 0, unitX * 0.3, 180, 270)}
            stroke={lineColor}
            fill="transparent"
            strokeWidth={props.lineThickness ? props.lineThickness : 3}
          />
          {/*RIGHT BOTTOM ARC */}
          <path
            d={describeArc(width + 5, height, unitX * 0.3, 270, 360)}
            stroke={lineColor}
            fill="transparent"
            strokeWidth={props.lineThickness ? props.lineThickness : 3}
          />
          {/*Right D-BOX ARC */}
          <path
            d={describeArc(
              width - (unitX + unitX * 0.25),
              height / 2,
              unitX + 5,
              210 + unitY * 0.3,
              330 - unitY * 0.3
            )}
            stroke={lineColor}
            fill="transparent"
            strokeWidth={props.lineThickness ? props.lineThickness : 3}
          />

          {/*Right D-BOX POINT */}
          <circle
            cx={width - (unitX + unitX * 0.2)}
            cy={height / 2}
            r={props.lineThickness ? props.lineThickness : 2}
            fill={lineColor}
          />
        </svg>
      )}
    </View>
  );
};

export default Field2D;
